
import React, {Component} from 'react';
import Iframe from '../../components/voteriframe/voteriframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Verifyregistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://verify.vote.org/?partner=111111&campaign=free-tools'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Verifyregistration;